import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import { twMerge } from 'tailwind-merge'
import { IMachine } from 'msp-integrations'
import AccountMachineDisplayStats from './AccountMachineDisplayStats/AccountMachineDisplayStats'
import AccountMachineRemove from './AccountMachineRemove/AccountMachineRemove'
import AccountMachineUpdate from './AccountMachineUpdate/AccountMachineUpdate'

import translations from './AccountMachineDisplay.constants'
import * as S from './AccountMachineDisplay.styles'

export type AccountMachineDisplayProps = {
  machine: IMachine
  className?: string
  disableActions?: boolean
}

const AccountMachineDisplay = ({
  machine,
  className = '',
  disableActions = false
}: AccountMachineDisplayProps) => {
  const { formatMessage, formatDate } = useIntl()
  const fallBackImage = getAssetUrl('static/img/fallback-product-image.png')
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions

  const purchaseDate = new Date(machine.purchaseDate)
  const warrantyExpiration = machine.warranty
    ? new Date(machine.warranty)
    : new Date(machine.purchaseDate)

  if (!machine.warranty) {
    warrantyExpiration.setFullYear(warrantyExpiration.getFullYear() + 2)
  }

  return (
    <div className={twMerge(S.Wrapper, className)}>
      <div className={S.LeftWrapper}>
        <div className={S.ImageWrapper}>
          <img
            alt={machine.model}
            src={machine.image || fallBackImage}
            className={S.Image}
          />
        </div>
        <AccountMachineDisplayStats machine={machine} />
      </div>
      <div className={S.RightWrapper}>
        <div className={S.MachineDetailsWrapper}>
          <div className={S.MachineDetailLineItem}>
            <div className={S.MachineDetailLabel}>
              {formatMessage(translations.model)}
            </div>
            <div className={S.MachineDetailContent}>
              {machine.model || machine.machineName}
            </div>
          </div>
          <div className={S.MachineDetailLineItem}>
            <div className={S.MachineDetailLabel}>
              {formatMessage(translations.purchaseDate)}
            </div>
            <div className={S.MachineDetailContent}>
              {formatDate(purchaseDate, dateFormattingOpts)}
            </div>
          </div>
          <div className={S.MachineDetailLineItem}>
            <div className={S.MachineDetailLabel}>
              {formatMessage(translations.warranty)}
            </div>
            <div className={S.MachineDetailContent}>
              {formatMessage(translations.warrantyExpiration, {
                expiryDate: formatDate(warrantyExpiration, dateFormattingOpts)
              })}
            </div>
          </div>
          <div className={S.MachineDetailLineItem}>
            <div className={S.MachineDetailLabel}>
              {formatMessage(translations.serialNumber)}
            </div>
            <div className={S.MachineDetailContent}>{machine.SerialNo}</div>
          </div>
        </div>
        {!disableActions && (
          <div className={S.MachineActionsWrapper}>
            <AccountMachineUpdate machine={machine} />
            <AccountMachineRemove machine={machine} />
          </div>
        )}
      </div>
    </div>
  )
}

export default AccountMachineDisplay
